/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./conversations.scss');

const deps = [require('ui/web/conversationList').name, require('ui/web/conversation').name];

module.exports = angular
  .module('bench.component.conversations', deps)

  .directive('blConversations', () => ({
    restrict: 'E',
    scope: {
      attachedTo: '@',
      clientId: '=',
      newConversationMessage: '@',
      commentReplyMessage: '@',
    },
    bindToController: true,
    template: require('./conversations.html'),
    controller: require('./conversationsCtrl.js'),
    controllerAs: 'vm',
  }));
